export const DeliveryStatus = {
  Eligible: _TL_('Eligible'),
  AssetGroupExpired: _TL_('Asset group expired'),
  AssetGroupUserPaused: _TL_('Asset group paused'),
  CampaignUserPaused: _TL_('Campaign paused'),
  CampaignBudgetPaused: _TL_('Campaign out of budget'),
  CampaignSuspended: _TL_('Campaign suspended'),
  CampaignInProgress: _TL_('Campaign incomplete'),
  ShoppingCampaignStoreNotFound: _TL_('Store not found'),
  ShoppingCampaignNoOffersPresent: _TL_('Product offers not found'),
  InvalidFinancialStatusOther: _TL_('Hold'),
  EditorialApprovedLimited: _TL_('Approved limited'),
  EditorialRejected: _TL_('Disapproved'),
  EditorialApprovedLimitedAppealRejected: _TL_('Approved limited, exception denied'),
  EditorialAppealRejected: _TL_('Disapproved, exception denied'),
  EditorialUnderAppeal: _TL_('Exception under review'),
  EditorialPending: _TL_('Pending editorial review'),
};

export const DeliveryStatusErrorList = [
  'AssetGroupExpired',
  'CreditCardExpired',
  'IOExceeded',
  'PaymentInformationMissing',
  'InvalidFinancialStatusOther',
  'MigrationPaused',
  'CampaignDeleted',
  'CampaignBudgetPaused',
  'AssetGroupDeleted',
  'CamAssetRejected',
  'EditorialRejected',
  'EditorialAppealRejected',
];

export const DeliveryStatusWhiteList = [
  'Eligible',
  'EditorialApprovedLimited',
  'EditorialApprovedLimitedAppealRejected',
  'Incomplete',
  'InlineOpportunity',
];
